
import { defineComponent, computed } from "vue";
import VueSlider from "vue-slider-component";
import "@/styles/slider.css";
import useStore from "@/composables/useStore";
import { useI18n } from "vue-i18n";
import formatCurrency from "@/utils/formatCurrency";

export default defineComponent({
    name: "PriceSelect",
    components: {
        VueSlider,
    },
    setup() {
        const { locale } = useI18n();
        const store = useStore();

        const priceMin = store.computed.priceMin;
        const priceMax = store.computed.priceMax;

        const { t, n } = useI18n();

        const value = computed({
            get() {
                return [
                    store.state.userSelection.priceMin,
                    store.state.userSelection.priceMax,
                ];
            },

            set([min, max]: Array<number>) {
                min ? store.actions.setPriceMin(min) : null;
                max ? store.actions.setPriceMax(max) : null;
            },
        });

        const minFormatted = computed(() =>
            formatCurrency(store.state.userSelection.priceMin / 100 ?? 0)
        );
        const maxFormatted = computed(() =>
            formatCurrency(store.state.userSelection.priceMax / 100 ?? 0)
        );

        function tooltipFormatter(value: number) {
            return formatCurrency(value / 100);
        }

        return {
            t,
            value,
            minFormatted,
            maxFormatted,
            priceMin,
            priceMax,
            tooltipFormatter,
        };
    },
});
